export const maskCharacterNcm = (value: string): string => {
  const cleanedValue = value.replace(/\D/g, "");
  const maxLength = 8;
  const truncatedValue = cleanedValue.slice(0, maxLength);

  if (truncatedValue.length === 0) {
    return "";
  }

  let maskedValue = truncatedValue;

  if (truncatedValue.length > 4) {
    maskedValue = maskedValue.slice(0, 4) + "." + maskedValue.slice(4);
  }

  if (truncatedValue.length > 6) {
    maskedValue = maskedValue.slice(0, 7) + "." + maskedValue.slice(7);
  }
  return maskedValue;
};

export const maskCharacterNaladi = (value: string): string => {
  const cleanedValue = value.replace(/\D/g, "");
  const maxLength = 8;
  const truncatedValue = cleanedValue.slice(0, maxLength);

  if (truncatedValue.length === 0) {
    return "";
  }

  let maskedValue = truncatedValue;
  return maskedValue;
};

const maskFormat = {
  maskCharacterNcm: maskCharacterNcm,
  maskCharacterNaladi: maskCharacterNaladi,
};

export default maskFormat;
